<template>
  <div>
    <Header></Header>
    <main id="content" role="main">
      <!-- Hero Section -->
      <div
        class="
          container
          space-top-3 space-top-lg-2 space-bottom-1 space-bottom-md-2
        "
        style="background-color:#f8f9fB"
      >
        <div class="w-md-80 w-lg-75 text-center mx-md-auto">
          <h2 class="display-5" style="font-weight:600">新闻公告</h2>
          <p class="lead" style="font-size:1.05rem;font-weight:549" >
            我们列出了用户提出的一些常见问题并予以解答，您可以查看是否对您有帮助。
          </p>
        </div>
      </div>
      <!-- End Hero Section -->
    
        <div class="container space-top-md-1 space-bottom-2 space-bottom-lg-2 mt-2
        " >
              <!-- Title -->
            <div class="row mb-4">
                <div class="col-6">
                <h2 class="h4 mb-0" style="font-weight:600;font-size:1.4rem">新闻公告</h2>
                </div>
                <div class="col-6 text-right">
                
                </div>
            </div>
      <!-- End Title -->
            <div class="row mb-3">
                <div class="col-sm-6 col-lg-4 mb-3 mb-sm-8 my-3"   v-for="(item,index) in ggList" :key="index">
                <!-- Blog Card -->
                <article class="card h-100" @click="skipDetail(item.contentId)" style="cursor:pointer;">
                    <div class="card-img-top position-relative">
                    <img class="card-img-top" v-if="item.fileId" :src="getImgUrl(item.fileId)" alt="Image Description">
                    <img class="card-img-top" v-else src="@/assets/img/image/news.jpg" alt="Image Description">
                    <figure class="ie-curved-y position-absolute right-0 bottom-0 left-0 mb-n1">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">
                        <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"/>
                        </svg>
                    </figure>
                    </div>

                    <div class="card-body" style="padding-bottom:0">
                    <h3><a class="text-inherit hover-color" style="font-weight:600;font-size:1.5rem" >{{item.title}}</a></h3>
                    <p class="mt-4" style="overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp:3;-webkit-box-orient: vertical;display: -webkit-box;text-align: justify;font-size:0.9rem">{{item.subtitle}}</p>
                    </div>

                    <div class="card-footer border-0 pt-0" style="background-color:white;">
                    <div class="media align-items-center media-body d-flex justify-content-start mt-1 text-white-70 font-size-1 " >
                       <span style="color:#c2c2c2">内容更新：{{getTime( item.releaseTime? item.releaseTime :  item.updateTime)}}</span> 
                    </div>
                    </div>
                </article>
                <!-- End Blog Card -->
                </div>
            </div>
             <!-- Pagination -->
            <el-pagination
                background
                :page-size="9"
                @current-change="getContent(columnId,$event)"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>
      <!-- End Pagination -->
        </div>    
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/vendor/jquery/dist/jquery.min.js";
import "@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js";

import "@/assets/vendor/font-awesome/css/all.min.css";
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.css";
import "@/assets/vendor/fancybox/dist/jquery.fancybox.min.css";
import "@/assets/vendor/aos/dist/aos.css";
import "@/assets/css/theme.css";
import "@/assets/vendor/hs-header/dist/hs-header.min.js";
import "@/assets/vendor/hs-go-to/dist/hs-go-to.min.js";
import "@/assets/vendor/hs-unfold/dist/hs-unfold.min.js";
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.js";
import "@/assets/vendor/fancybox/dist/jquery.fancybox.min.js";
import "@/assets/vendor/appear.js";
import "@/assets/vendor/circles/circles.min.js";
import "@/assets/vendor/polifills.js";
import AOS from "aos";
// import 'aos/dist/aos.css'

// import 'bootstrap'
// import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@/assets/js/hs.core.js";
import "@/assets/js/hs.fancybox.js";

import "@/assets/js/hs.circles.js";
import "@/assets/vendor/hs-counter/dist/hs-counter.min.js";
import Header from "../components/header";
import Footer from "../components/footer";
import moment from 'moment'
import { getsycolumn, getsyres, getsy1,getsy } from "../request/index";
export default {
  components: {
    Header,
    Footer,
  },

  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
    $(document).ready(function () {
      //   console.log("ccccc",HSHeader)
      //   var header = new HSHeader($("#header")).init();

      // initialization of mega menu
      var megaMenu = new HSMegaMenu($(".js-mega-menu"), {
        desktop: {
          position: "left",
        },
      }).init();

      // initialization of unfold
      var unfold = new HSUnfold(".js-hs-unfold-invoker").init();

      // initialization of fancybox
      $(".js-fancybox").each(function () {
        var fancybox = $.HSCore.components.HSFancyBox.init($(this));
      });

      // initialization of circles
      $(".js-circle").each(function () {
        var circle = $.HSCore.components.HSCircles.init($(this));
      });

      //initialization of aos
      AOS.init({
        duration: 650,
        once: true,
      });
      // if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) document.write('<script src="@/assets/vendor/polifills.js"><\/script>');
      // initialization of go to
      $(".js-go-to").each(function () {
        var goTo = new HSGoTo($(this)).init();
      });
      $(".js-counter").each(function () {
        var counter = new HSCounter($(this)).init();
      });
    });
  },
  data() {
    return {
      ggList: [],
      columnId:null,
      page:0,
      size:9,
      total:null
    };
  },
  created() {
    this.getFirst()
  },
  methods:{
    // 获取当前栏目
    getFirst(){
      getsycolumn(0).then(res=>{
        let arr = res.data;
        arr.forEach(item=>{
          if(item.title == "公告动态"){
              this.columnId = item.columnId; 
              this.getContent(item.columnId)
          }
        })
      })
    },
    // 获取内容
    getContent(id,val){
        if(val && val>0){
            this.page = val -1
        }
      getsy1(id,{page:this.page,size:this.size}).then(res=>{
          let arr = res.data.content
          this.total = res.data.totalElements
          this.ggList = res.data.content
          arr.forEach((item,index)=>{
            item.showImgStatu = false
            this.getSource(item,item.contentId,index)
          })
      })
    },
     // 获取内容资源资源
    getSource(obj,id,index){
      getsyres(id).then(res=>{
        let arr = res.data
        console.log(192,arr)
        if(arr && arr.length>0){
          arr.forEach(hs=>{
              if(hs.keystring == '封面'){
                  obj.fileId = hs.fileId
                  this.$set(this.ggList,index,obj)
              } 
          })
        }
      })
    },
    // 图片地址
    getImgUrl(id){
      return process.env.NODE_URL + "api/files/getFileStream?fileId="+id
    },
    // 跳转详情
    skipDetail(id){
      this.$router.push({path:'/articleDetail',query:{id:id}})
    },
    // 时间转换
    getTime(val){
        return moment(val).get('year') + " 年 " + (parseInt(moment(val).get('month')) + 1) + " 月 " + moment(val).get('date') + " 日"
    }
  }
};
</script>

<style scoped>
.bg-img-hero {
  background: url("../assets/svg/components/abstract-shapes-5.svg") center;
}
.pb-5,
.py-5 {
  padding: 2rem 0 !important;
}
.text-dark {
  line-height: 1.6;
  color: #1e2022 !important;
}
.text-body {
  color: #677788 !important;
}
.mb-3 h4 {
  margin-bottom: 0.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.4;
}
.col-sm-12 h4 {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.4;
}
.col-sm-12 p {
  font-size: 0.875rem;
  color: #677788 !important;
}
#stickyBlockStartPoint {
  position: sticky !important;
  position: -webkit-sticky;
  top: 10px;
  
}
.pl-lg-4 .h3 {
  margin-bottom: 0.5rem;
  font-size: 1.3125rem;
  font-weight: 600;
  line-height: 1.4;
}
.pl-lg-4 p {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
}
.font-weight-normal {
  font-size: 1.875rem;
  line-height: 1.4;
}
.mx-lg-auto .mb-0 {
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.text-muted {
  font-weight: 400;
  color: #8c98a4 !important;
  line-height: 1.6;
}
a {
  text-decoration: none;
}
.mb-md-9 h2 {
  font-size: 1.875rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.card-body .mb-0 {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.6;
}
.card-body .mb-01 {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.6;
}
.mx-lg-auto .mb-00 {
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.4;
}
.hover-color:hover{
  color: #377dff
}
.container >>> .el-pagination{
  padding-left: 0;
}
.container >>>.el-pagination button{
  margin-left:0 ;
  margin-right:0 ;
}
.container >>> .el-pagination .active{
  background-color: #377dff !important
}
</style>


// WEBPACK FOOTER //
// src/view/gonggao.vue